import axios from 'axios';
import React, { useEffect, useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Button from '../components/Button';
import Card from '../components/Card';
import FlexBox from '../components/FlexBox';
import Icon from '../components/Icon';
import { UserContext } from '../context/UserContext';
import Status from '../types/enum/Status';
import LogoImage from '../assets/logonew3.png';
import { SemesterContext } from '../context/SemesterContext';
import { Col, Row } from '../components/StyledGridSystem';

const SignOutCard = styled(Card)`
  text-align: center;
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(90deg, #b03434 0%, #184b68 118.29%);
`;

function SignOutPage() {
  const [isSignOutComplete, setSignoutComplete] = useState(false);
  const { isSignedIn, signOut } = useContext(UserContext);
  const semesterContext = useContext(SemesterContext);

  useEffect(() => {
    if (isSignedIn) {
      localStorage.clear();
      semesterContext.clearSemesterState();
      axios
        .get('/logout')
        .then((res) => {
          signOut();
          localStorage.clear();
          setSignoutComplete(true);
        })
        .catch((err) => {
          console.error(err);
          signOut();
          localStorage.clear();
          setSignoutComplete(true);
        });
    } else {
      localStorage.clear();
      semesterContext.clearSemesterState();
      setSignoutComplete(true);
    }
  }, [isSignedIn, signOut]);
  return (
    <>
      {isSignOutComplete && (
        <Row>
          <Col>
            <SignOutCard>
              <FlexBox
                direction="column"
                justify="center"
                style={{ height: '100%' }}
                space={3}
                alignItems="center">
                <img src={LogoImage} alt="" style={{ marginBottom: '24px' }} />

                <h2>You are now signed out.</h2>
                <p>Thank you for using A1CE. Have a good day!</p>
                <p>
                  Need to get back in? <Link to="/signin">Sign in again</Link>.
                </p>
              </FlexBox>
            </SignOutCard>
          </Col>
        </Row>
      )}

      {/* <Redirect to="/" /> */}
    </>
  );
}

export default SignOutPage;
